import React, { memo } from 'react'
import moment from 'moment'
import { Empty } from 'antd'
import { useHistory } from 'react-router-dom'
import { EmptyText } from '../../components/Common/CellText'
import FileItem from '../../components/Common/FileItemComponent/FileItem'
import utils from '../../utils'
import {
  BodyTableLeft,
  BodyTableRight,
  BodyTableWrapper,
  HeaderTableWrapper,
  ItemTableRight,
} from '../CompanyWorkScheduleListPage/CompanyWorkScheduleListPageStyled'
import { shouldUseParentWorkScheduleView } from '../../utils/imsatWorkScheduleUtils'
import { DATE_FORMAT_DEFAULT } from '../../constants'

const renderTime = value => {
  return `${String(moment(value).hour()).padStart(2, '0')}h${String(
    moment(value).minute()
  ).padStart(2, '0')}`
}

const renderDate = value => {
  return `${String(moment(value).date()).padStart(2, '0')}/${String(
    moment(value).month() + 1
  ).padStart(2, '0')}`
}

const OfficeCalendar = props => {
  const {
    data = [],
    onEventClick,
  } = props || {}

  const checkIsTodayWorkSchedule = date =>
    date && moment(date).format(DATE_FORMAT_DEFAULT) ===
    moment().format(DATE_FORMAT_DEFAULT)

  // ─── Prepare data ─────────────────────────────────────────────────────────────
  const tableData = data?.map(item => ({
    ...item,
    weekDay: moment(item.start_at).isoWeekday(),
  })) || []

  const convertTableData = [
    { weekday: 1, workSchedule: [] },
    { weekday: 2, workSchedule: [] },
    { weekday: 3, workSchedule: [] },
    { weekday: 4, workSchedule: [] },
    { weekday: 5, workSchedule: [] },
    { weekday: 6, workSchedule: [] },
    { weekday: 7, workSchedule: [] },
  ]

  tableData.forEach(item => {
    if (item.weekDay >= 1 && item.weekDay <= 7) {
      convertTableData[item.weekDay - 1].workSchedule.push(item)
    }
  })

  // Sort events in each day by start time
  convertTableData.forEach(day => {
    day.workSchedule.sort((a, b) => moment(a.start_at).valueOf() - moment(b.start_at).valueOf())
  })

  const sum = convertTableData.reduce(
    (previousValue, currentValue) =>
      previousValue + currentValue.workSchedule.length,
    0
  )

  const isParentCompanySelected = false // We can get this from parent if needed

  const headerTable = (
    <HeaderTableWrapper style={{ 
      backgroundColor: '#e6f7ff', 
      color: 'rgba(0, 0, 0, 0.85)',
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      borderBottom: '1px solid #f0f0f0',
      fontWeight: 600,
    }}>
      <span className={'date'}>Ngày tháng</span>
      <span className={'element'}>Nội dung công việc</span>
      <span className={'element'}>Chuẩn bị</span>
      <span className={'element'}>Thành viên tham gia</span>
      <span className={'element'}>Địa điểm</span>
      <span className={'element'}>Chủ trì</span>
    </HeaderTableWrapper>
  )

  return (
    <div style={{ width: '100%', fontSize: 14 }}>
      <div style={{ width: '100%', overflowX: 'auto' }}>
        {headerTable}
        
        {convertTableData.length > 0 && (
          <div style={{ marginTop: 0, position: 'relative' }}>
            {convertTableData.map(el => {
              if (el.workSchedule.length === 0) return null
              
              const isToday = checkIsTodayWorkSchedule(el.workSchedule[0].start_at)
              
              return (
                <div
                  key={el.weekday}
                  style={{
                    display: 'flex',
                    marginBottom: 20,
                    border: '1px solid #f0f0f0',
                    borderLeft: isToday ? 'none' : '1px solid #f0f0f0',
                  }}>
                  <BodyTableLeft
                    style={{
                      backgroundColor: isToday ? '#e9f0fd' : '#ffffff',
                      borderLeft: isToday ? '3px solid #e6f7ff' : 'none',
                      borderRight: '1px solid #f0f0f0',
                    }}>
                    <div>{utils.renderWeekday(el.weekday)}</div>
                    <div>{renderDate(el.workSchedule[0].start_at)}</div>
                  </BodyTableLeft>
                  
                  <div style={{ flexGrow: 1, backgroundColor: isToday ? '#e9f0fd' : '#ffffff' }}>
                    {el.workSchedule.map((item, index) => (
                      <BodyTableWrapper key={item.schedule_code || index}>
                        <BodyTableRight>
                          <ItemTableRight
                            onClick={() => onEventClick?.({ ...item, id: item.schedule_code })}>
                            <strong style={{ fontWeight: 'bold', display: 'block', marginBottom: 4 }}>
                              {renderTime(item.start_at)}
                              {item.end_at && ` đến ${renderTime(item.end_at)}`}
                            </strong>
                            <div>
                              {item.event_notice ? (
                                utils.removeHtml(item.event_notice)
                              ) : (
                                <EmptyText>Không có nội dung</EmptyText>
                              )}
                            </div>
                            {item.file_ids?.map(file => (
                              <FileItem
                                key={file.file_id}
                                file_id={file.file_id}
                                file_name={file.file_title}
                                isParentFile={shouldUseParentWorkScheduleView(
                                  item,
                                  isParentCompanySelected
                                )}
                                file_type={utils.getExtensionFile(file.file_title)}
                              />
                            ))}
                          </ItemTableRight>
                          <ItemTableRight onClick={() => onEventClick?.({ ...item, id: item.schedule_code })}>
                            {item.preparation ? item.preparation : <EmptyText>Không có chuẩn bị.</EmptyText>}
                          </ItemTableRight>
                          <ItemTableRight onClick={() => onEventClick?.({ ...item, id: item.schedule_code })}>
                            {item.attenders ? item.attenders : <EmptyText>Không có thành viên tham gia.</EmptyText>}
                          </ItemTableRight>
                          <ItemTableRight onClick={() => onEventClick?.({ ...item, id: item.schedule_code })}>
                            {item.location ? item.location : <EmptyText>Không có địa điểm.</EmptyText>}
                          </ItemTableRight>
                          <ItemTableRight onClick={() => onEventClick?.({ ...item, id: item.schedule_code })}>
                            {item.host ? item.host : <EmptyText>Không có chủ trì.</EmptyText>}
                          </ItemTableRight>
                        </BodyTableRight>
                      </BodyTableWrapper>
                    ))}
                  </div>
                </div>
              )
            })}
          </div>
        )}

        {sum === 0 && (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={'Không có dữ liệu'}
            style={{ marginTop: 50 }}
          />
        )}
      </div>
    </div>
  )
}

export default memo(OfficeCalendar)
